"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _styles = require("@material-ui/core/styles");
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  icon: {
    background: theme.palette.primary.main,
    border: "0 none",
    borderRadius: "50%",
    color: theme.palette.common.white,
    cursor: "pointer",
    display: "block",
    height: 24,
    marginBottom: theme.spacing(0.5),
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: theme.spacing(1.5),
    padding: 0,
    textAlign: "center",
    width: 24,
    [theme.breakpoints.up("lg")]: {
      marginTop: theme.spacing(4.5)
    }
  }
}));
const SearchButton = _ref => {
  let {
    lang
  } = _ref;
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/".concat(lang, "/info-az")
  }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    className: css.icon,
    src: "/img/icons/search.svg",
    size: 16
  }));
};
var _default = exports.default = SearchButton;